<template>
  <div class="date-panel">
    <input type="text" v-model="currentDate" class="selectedDate" placeholder="请选择日期范围" @click="openDatePanel" readonly :disabled="disabledInput" :class="{disable: disabledInput}">
    <transition name="slide">
      <div class="date-range" v-show="showPanel">
        <div class="wrapper clearfix">
          <div class="operatePanel fl">
            <p class="curDate">
              <span>开始</span>
              <el-input type="text" v-model="beginDate" @change="bDateChange"></el-input>
            </p>
            <p class="curDate">
              <span>结束</span>
              <el-input type="text" v-model="finishDate" @change="fDateChange"></el-input>
            </p>
            <div class="shortcut">
              <p v-if="shortcut">
                <span @click="setLastDay(-1)">昨天</span>
                <span @click="setLastDay(-3)">过去3天</span>
                <span @click="setLastDay(-5)">过去5天</span>
                <span @click="setLastDay(-7)">过去7天</span>
                <span @click="setLastDay(-15)">过去15天</span>
                <span @click="setLastDay(-30)">过去30天</span>
                <!--<span @click="currentMonth">本月</span>-->
                <span @click="lastMonth">上个月</span>
              </p>
            </div>
            <p class="btnGroup">
              <el-button @click="sendDateRange">确定</el-button>
              <el-button @click="clearDate">取消</el-button>
            </p>
          </div>
          <div class="dateWrapper fr clearfix">
            <dateSelect class="fl borderRight" :date="beginDate" :options="beginDateOpt" :disabledDate="beginDateDisable" @selected="selectBDate"></dateSelect>
            <dateSelect class="fl" :date="finishDate" :options="finishDateOpt" @selected="selectFDate" :disabledDate="finishDateDisable" :associatedDate="associatedDate"></dateSelect>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getDiffDate, getBeginAndEndDateOfMonth } from '../util/date';
import dateSelect from './date-select.vue';
export default {
  data () {
    return {
      beginDate: '',
      finishDate: '',
      currentDate: [],
      showPanel: false,
      beginDateDisable: () => { },
      finishDateDisable: () => { },
      beginDateOpt: {},
      finishDateOpt: {},
      associatedDate: () => { }
    };
  },
  props: {
    defaultDate: {
      type: Array,
      default: () => {
        return [];
      }
    },
    disBeginDate: {
      type: Function
    },
    disFinishDate: {
      type: Function
    },
    shortcut: {
      type: Boolean,
      default: false
    },
    disabledInput: {
      type: Boolean,
      default: false
    }
  },
  created () {
    // 设置默认日期范围
    this.currentDate = this.defaultDate.length > 0 ? (this.defaultDate[0] + '~' + this.defaultDate[1]) : [];
    this.setOptions();
  },
  methods: {
    openDatePanel () {
      this.showPanel = !this.showPanel;
    },
    clearDate () {
      this.currentDate = [];
      this.beginDate = '';
      this.finishDate = '';
      this.showPanel = false;
    },
    selectBDate (date) {
      let that = this;
      this.beginDate = date;
      this.finishDate = date;
      this.associatedDate = function (time) {
        return new Date(time) < new Date(that.beginDate);
      };
    },
    selectFDate (date) {
      this.finishDate = date;
    },
    bDateChange (date) {
      this.beginDate = date;
    },
    fDateChange (date) {
      this.finishDate = date;
    },
    setOptions () {
      this.beginDateOpt.dateType = 'start';
      this.finishDateOpt.dateType = 'end';
      this.beginDateDisable = this.disBeginDate;
      this.finishDateDisable = this.disFinishDate;
    },
    sendDate (dateArr) {
      this.$emit('receiveDate', dateArr);
    },
    sendDateRange () {
      this.currentDate = this.beginDate + '~' + this.finishDate;
      this.sendDate([this.beginDate, this.finishDate]);
      this.showPanel = false;
    },
    setLastDay (day) {
      const { startDate, endDate } = getDiffDate(day)

      this.beginDate = startDate;
      this.finishDate = endDate;
    },
    currentMonth () {
      const [startDate, endDate] = getBeginAndEndDateOfMonth()

      this.beginDate = startDate;
      this.finishDate = endDate;
    },
    lastMonth () {
      const [startDate, endDate] = getBeginAndEndDateOfMonth(-1)

      this.beginDate = startDate;
      this.finishDate = endDate;
    }
  },
  components: {
    dateSelect
  },
  watch: {
    disBeginDate () {
      this.beginDateDisable = this.disBeginDate;
    },
    disFinishDate () {
      this.finishDateDisable = this.disFinishDate;
    }
  }
};
</script>

<style lang="scss">
.fl {
  float: left;
}
.fr {
  float: right;
}
.slide-enter-active {
  transition: all 0.3s ease-in;
}
.slide-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-enter,
.slide-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
.date-panel {
  position: relative;
  .selectedDate {
    width: 205px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #bdbdbd;
    box-sizing: border-box;
    color: #0f1a23;
    font-size: 14px;
    outline: 0;
    cursor: pointer;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  }
  .selectedDate::-webkit-input-placeholder {
    color: #1d2b36;
  }
  .date-range {
    position: absolute;
    top: 35px;
    left: 0;
    width: 764px;
    height: 345px;
    z-index: 11000;
    border-radius: 3px 3px;
    background: #fff;
    border-top: 10px solid #0e1922;
    box-shadow: 1px 11px 30px 5px #ccc;
  }
  h3 {
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #0e1922;
    border-radius: 3px 3px 0 0;
    span {
      float: left;
      margin-left: 25px;
      color: #b5c2ca;
    }
    i {
      float: right;
      margin-right: 10px;
      font-size: 30px;
      line-height: 35px;
      color: #ababab;
      cursor: pointer;
    }
  }
  .operatePanel {
    width: 170px;
    height: 345px;
    border-right: 1px solid #f8f8f8;
    .curDate {
      width: 152px;
      height: 28px;
      border: 1px solid #3dc1c4;
      border-radius: 30px 30px;
      margin-top: 15px;
      margin-left: 9px;
      span {
        float: left;
        width: 53px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        background: #3dc1c4;
        color: #fff;
        border-radius: 30px 0 0 30px;
      }
      .el-input {
        float: left;
        width: 99px;
      }
      .el-input__inner {
        border-color: transparent;
      }
      .el-date-editor .el-input__inner {
        padding: 0 !important;
      }
      input {
        float: left;
        width: 99px;
        height: 28px;
        line-height: 28px;
        text-align: center;
        border-radius: 30px 30px;
      }
    }
  }
  .shortcut {
    width: 161px;
    height: 102px;
    margin-left: 9px;
    margin-top: 30px;
    span {
      display: inline-block;
      height: 22px;
      padding: 0 10px;
      line-height: 22px;
      text-align: center;
      font-size: 12px;
      border-radius: 30px 30px;
      margin-bottom: 10px;
      border: 1px solid #bac6ce;
      cursor: pointer;
      margin-right: 5px;
    }
    span:hover {
      color: #3dc1c4;
      border-color: #3dc1c4;
    }
  }
  .btnGroup {
    margin-left: 9px;
    margin-top: 75px;
    button {
      float: left;
      padding: 0;
      width: 50px;
      height: 24px;
      line-height: 24px;
      text-align: center;
      color: #fff;
      border-radius: 3px 3px;
      background: #3dc1c4;
      margin: 0 10px;
      border-color: #3dc1c4;
    }
  }
  .borderRight {
    border-right: 1px solid #f1f1f1;
  }
  .disable {
    background-color: #eef1f6;
    border-color: #d1dbe5;
    color: #bbb;
    cursor: not-allowed;
  }
  .disable::-webkit-input-placeholder {
    color: #bbb;
  }
}
</style>
